import { useEffect } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Link as RouterLink,
  useLocation,
  matchPath,
} from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Box,
  Divider,
  Drawer,
  Hidden,
  List,
  ListSubheader,
} from '@material-ui/core';

import Logo from 'components/Logo';
import { parseIfValid } from 'utils/json';
import { hasPermissions } from 'utils/permissions';
import { firstLetter } from 'utils/strings';

import NavItem from './NavItem';
import useStyles from './styles';
import { items } from './constants/items';
import { canUseCatalog } from 'utils/pos'; //TODO: Una vez pasada la beta retirar

const company = parseIfValid(localStorage.getItem('company'), false);

function renderNavItems({ items, ...rest }) {
  const showByCompany = {};
  const isSandboxAccount =
  parseIfValid(localStorage.getItem('isSandbox'), false) === true;
  const hasCatalog = canUseCatalog(); //TODO: Una vez pasada la beta retirar

  let options = items
    .filter((item) => {
      if (typeof item.isSandbox === 'boolean') {
        return item.isSandbox === isSandboxAccount;
      }
      return true;
    })
    .filter((item) => { ////TODO: Una vez pasada la beta retirar
      if (item.requiresCatalog) {
        return hasCatalog;
      }
      return true;
    }) //TODO: Eliminar hasta aquí
    .filter((item) => (item.href in showByCompany)
      ? showByCompany[item.href].includes(company?.id)
      : true);

  options = options
    .filter((item) => {
      if ([null, undefined, ''].includes(item.module)) {
        return true;
      }

      const permissionName = Array.isArray(item.module)
        ? item.module.map((itemModule) => `${itemModule}.select.list${firstLetter(itemModule)}`)
        : `${item.module}.select.list${firstLetter(item.module)}`;

      return hasPermissions(permissionName, true);
    });

  return (
    <List disablePadding>
      {options.reduce(
        (acc, item) => reduceChildRoutes({
          acc,
          item,
          ...rest,
        }),
        [],
      )}
    </List>
  );
}

function reduceChildRoutes({ acc, pathname, item, depth = 0 }) {
  const key = item.title + depth;

  if (item.items) {
    const open = matchPath(pathname, {
      path: item.href,
      exact: false,
    });

    acc.push(
      <NavItem
        depth={depth}
        icon={item.icon}
        key={key}
        info={item.info}
        open={Boolean(open)}
        title={item.title}
      >
        {renderNavItems({
          depth: depth + 1,
          pathname,
          items: item.items.filter(_ => !_.hidden),
        })}
      </NavItem>,
    );
  } else {
    acc.push(
      <NavItem
        depth={depth}
        href={item.href}
        icon={item.icon}
        key={key}
        info={item.info}
        title={item.title}
      />,
    );
  }

  return acc;
}

function NavBar({ openMobile, openMenu, onMobileClose }) {
  const classes = useStyles();
  const location = useLocation();

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
  }, [location.pathname]);

  const navConfig = [
    {
      items: items,
      permissions: [],
      subheader: '',
    },
  ];

  const content = (
    <Box height="100%" display="flex" flexDirection="column">
      <PerfectScrollbar options={{
        suppressScrollX: true,
      }}>
        <Hidden lgUp>
          <Box p={2} display="flex" justifyContent="center">
            <RouterLink to="/">
              <Logo
                style={{
                  maxHeight: 32,
                }}
                variant="imagotipo-horizontal"
              />
            </RouterLink>
          </Box>
        </Hidden>

        <Divider />
        <Box p={2}>
          {navConfig.map((config, index) => (
            <List
              key={index}
              subheader={
                <ListSubheader
                  children={config.subheader}
                  disableGutters
                  disableSticky
                />
              }
            >
              {renderNavItems({
                items: config.items,
                pathname: location.pathname,
              })}
            </List>
          ))}
        </Box>
      </PerfectScrollbar>
    </Box>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          children={content}
          classes={{
            paper: classes.mobileDrawer,
          }}
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
        />
      </Hidden>
      <Hidden mdDown>
        <Drawer
          anchor="left"
          children={content}
          classes={{
            paper: classes[openMenu
              ? 'desktopDrawer'
              : 'desktopMiniDrawer'],
          }}
          open={openMenu}
          variant="persistent"
        />
      </Hidden>
    </>
  );
}

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool,
  openMenu: PropTypes.bool,
};

export default NavBar;
